import { Pencil } from 'lucide-react';

export interface PilulaEditarProps {
  /** Opens the in-session editor on the current card. */
  onClick: () => void;
}

export function PilulaEditar({ onClick }: PilulaEditarProps) {
  return (
    <button
      type="button"
      data-editor-entrada=""
      onClick={onClick}
      className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-admin/[0.35] bg-admin/[0.15] px-3 py-[7px] text-xs font-semibold text-admin-ink outline-none hover:bg-admin/[0.22] focus-visible:ring-2 focus-visible:ring-admin/[0.42]"
    >
      <Pencil size={13} className="text-admin" aria-hidden />
      Editar
    </button>
  );
}
